import { Component, Input, OnInit } from '@angular/core';
import IZoningCodePerformanceData = ZoningAPI.IZoningCodePerformanceData;

@Component({
    standalone: false,
    selector: 'app-zc-performance-details-view',
    templateUrl: './zc-performance-details-view.component.html',
    styleUrls: ['./zc-performance-details-view.component.scss']
})
export class ZcPerformanceDetailsViewComponent implements OnInit {
    @Input()
    zcStatistic: IZoningCodePerformanceData;

    constructor() {}

    ngOnInit(): void {}
}
